export default __webpack_public_path__ + "static/media/phone_rewards.e608c6ca.jpg";